<template>
  <b-form @submit.stop.prevent>
    <div class="d-flex flex-row flex-wrap">
      <div class="col-12 px-0">
        <filter-master
          v-model="filterMaster"
          :m-headquarter-id="
            editData && editData.mHeadquarterId
              ? editData.mHeadquarterId
              : !authUser.canAccessAllHeadQuarters
              ? authUser.mHeadquarterId
              : null
          "
          :m-division-id="
            editData && editData.mDivisionId
              ? editData.mDivisionId
              : !authUser.canAccessAllDivisions
              ? authUser.mDivisionId
              : null
          "
          :disabled-input="disabledInput"
          col-headquarter="12"
          col-division="12"
          default-label="-"
          :hidden-input="{ station: true, school: true, schoolClass: true }"
          :invalid="invalid"
          :validation="validation"
        >
        </filter-master>
      </div>

      <div class="col-12 px-2 mb-2">
        <label class="font-weight-bold" for="stationName">สถานี</label>

        <b-form-input
          id="stationName"
          :state="invalid ? validation.form.m_station_name.required : null"
          type="text"
          :disabled="disabled"
          v-model="form.m_station_name"
        ></b-form-input>

        <b-form-invalid-feedback id="stationName-feedback">
          กรุณากรอกสถานี
        </b-form-invalid-feedback>
      </div>
    </div>
  </b-form>
</template>

<script>
import { Auth } from "../../models";
import FilterMaster from "./FilterMaster";

export default {
  props: {
    formData: Object,
    editData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Object,
    },
    invalid: {
      type: Boolean,
      default: false,
    },
    disabledInput: {
      type: Object,
      default: () => ({}),
    },
  },

  model: {
    prop: "formData",
    event: "change",
  },

  components: {
    FilterMaster,
  },

  data() {
    return {
      form: {
        m_station_name: this.editData.m_station_name || "",
      },
      filterMaster: {
        mHeadquarterId: this.editData.mHeadquarterId || null,
        mDivisionId: this.editData.mDivisionId || null,
      },
    };
  },

  watch: {
    form: {
      deep: true,
      immediate: true,
      handler: "syncData",
    },
    filterMaster: {
      deep: true,
      immediate: true,
      handler: "syncFilterMaster",
    },
  },

  computed: {
    authUser() {
      return Auth.user();
    },
  },

  methods: {
    syncData(v) {
      this.$emit("change", v);
    },

    syncFilterMaster(v) {
      this.$emit("update:filterMaster", v);
    },
  },
};
</script>
